import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';

export interface LieferantenrechnungAraPosition {
    rNr: string;
    rPos: number;
    artikelGruppeNr: number;
    artikelNr: string;
    pos: number;
    posText: string;
    posEinh: string;
    posMenge: number;
    posEkPreis: number;
    posEPreis: number;
    posNetto: number;
    posMwst: number;
    posBrutto: number;
    posBem: string;
    lkz: number;
    pd: number;
    pz: number;
    lNr: number;

    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export interface LieferantenrechnungAraPositionFilter {
    rNrList?: string[];
    kNr?: number;
    rNr?: string;
    rPos?: number;
    pos?: number;
}

export const defaultLieferantenrechnungAraPosition: LieferantenrechnungAraPosition = {
    rNr: '',
    rPos: 0,
    artikelGruppeNr: 0,
    artikelNr: '',
    pos: -1, // -1 = new
    posText: '',
    posEinh: '',
    posMenge: 0,
    posEkPreis: 0,
    posEPreis: 0,
    posNetto: 0,
    posMwst: 20,
    posBrutto: 0,
    posBem: '',
    lkz: 0,
    pd: 0,
    pz: 0,
    lNr: 0,
};

export function useLieferantenrechnungAraPositionList(
    filter: LieferantenrechnungAraPositionFilter,
    apiOptions?: UseApiOptions<LieferantenrechnungAraPosition[]>,
): QueryResult<LieferantenrechnungAraPosition[]> {
    return useApi<LieferantenrechnungAraPosition[]>(
        Controller.lieferantenrechnungAraPosition + '/list',
        { filter },
        apiOptions,
    );
}

interface AddLieferantenRechnungAraPositionResult {
    newNr: number;
}

export async function addLieferantenrechnungAraPosition(
    lieferantenrechnungAraPosition: LieferantenrechnungAraPosition,
): Promise<AddLieferantenRechnungAraPositionResult> {
    return callApi<AddLieferantenRechnungAraPositionResult>(Controller.lieferantenrechnungAraPosition + '/add', {
        lieferantenrechnungAraPosition,
    });
}

export async function updateLieferantenrechnungAraPosition(
    lieferantenrechnungAraPosition: LieferantenrechnungAraPosition,
): Promise<void> {
    return callApi<void>(Controller.lieferantenrechnungAraPosition + '/update', { lieferantenrechnungAraPosition });
}

export async function deleteLieferantenrechnungAraPosition(
    lieferantenrechnungAraPosition: LieferantenrechnungAraPosition,
): Promise<void> {
    return callApi<void>(Controller.lieferantenrechnungAraPosition + '/delete', { lieferantenrechnungAraPosition });
}
